import { string } from "yup";
import {
  ITreatmentRoom,
  TMultyCompanyDetails,
  TSpecialization,
  TTherapistSpecialization,
  TTherapistUser,
  TUserAppointment,
} from "../services/types/user.types";
import { chatNoteTypes, IOption } from "../utils/constants";

export const migzarOptions = [];

export type TLocationState = {
  pathname: string;
  state: { pathname: string };
};
export interface IDocumentsToFilter {
  status: string;
  urgent: boolean;
  issued: Date;
}
export interface ITherapistDocument {
  id: string;
  userId: string;
  issued: Date;
  urgent: boolean;
  status: string;
  category: string;
}
export type LangTranslate = {
  language: string;
  translate: string;
  code: string;
};
export interface IPrescription extends ITherapistDocument {
  medicine: string;
  doze: string;
  instructions: string;
  exp: Date;
}
export interface IDatedText {
  id: number;
  text: string;
  date: Date;
  link?: string;
  linkText?: string;
  createdUserName?: string;
}

export interface IAdminMessage {
  Id: number;
  Title: string;
  Desc: string;
  CompanyId: number;
  RoleId: number;
  StatusId: number;
  UpdatedAt: string;
  CreatedUserName?: string;

}

export interface ITherapist {
  [key: string]: any;
  id: string | number;
  roleId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  account: string;
  avatar: string;
  email: string;
  degree: string;
  phone: string;
  address: string;
  therapistSpecializations: TTherapistSpecialization[]; // fields?: string[]; //תחומי טיפול
  allSpecializations: TSpecialization[];
  password?: string;
  unreadMessages: number;
  availability: IAvailability[];
  about?: string;
  allowPatientBooking?: boolean;
  videos?: IVideo[];
  mainPageTexts?: IDatedText[];
  companyId: number;
  treatmentPlan: ITreatmentPlan[];
  MigzarId: number;
  GenderId: number;
  vetek: number | null;
  TreatmentGroupId?: number | null;
  usersMultipleCompanies?: TMultyCompanyDetails[];
}

export interface IUser {
  [key: string]: any;
  id: string;
  guid: string;
  firstName: string;
  lastName: string;
  fullName: string;
  account: string;
  avatar: string;
  email: string;
  phone: string;
  address: string;
  plan: string;
  therapists: ITherapist[];
  appointments: [];
  settings: ISettings;
  prescriptions: IPrescription[];
  invoices: IInvoice[];
  videos: IVideo[];
  password: string; //remove when server is ready
  card?: string;
  unreadMessages: number;
  myDayText?: "";
  myTreatmentText?: "";
  passport?: string | null;
  country?: string | null;
  messages?: IMessage[];
  statusId?: number;
}
export enum Category {
  Messages = "messages",
  Main = "main",
  RecordMeeting = "recordMeeting",
  Users = "users",
  Library = "library",
  Support = "support",
  Terms = "terms",
  Profile = "profile",
  Calendar = "calendar",
  Forum = "forum",
  TreatmentPlan = "treatmentPlan",
  Tutorial = "tutorial",
  
}
// export interface IAppointment {
//   id: number;
//   userName: string;
//   userId: string;
//   date: Date;
// }

export interface IMessage {
  id: string;
  date: string;
  message: string;
  unread: boolean;
}
export interface IChatMessage {
  Type?: string;
  senderId: number;
  content: string;
  receiverId: number;
  sentDate?: string;
}
export type ChatMessage = {
  userid: string;
  therapistid: string;
  answer: string;
  question: string;
  dateTime: Date;
};

export type ExtendedChatMessage = {
  from: "user" | "ai";
  message: IChatMessage;
};

export interface IAppointmentDay {
  date: string;
  appointments: any;
}

export interface ISettings {
  sendToEmail: boolean;
  sendAds: boolean;
  sendNotifications: boolean;
}

export interface IInvoice {
  id: string;
  date: Date;
  sum: string;
}

export interface IVideo {
  link: string;
  title: string;
  about: string;
  category?: string;
}

export interface IPopupWithoutProps {
  onClose: () => void;
}

export interface IScannedDoc {
  name: string;
  date: Date;
  status: string;
}

export interface INotification {
  unread: boolean;
  text: string;
  section: string;
}
export interface IForummessage {
  id: string;
  user: {
    userName: string;
    avatar: string;
    tag?: string;
    date: Date;
  };
  message: string;
  replyTo?: string;
}
export interface IForumThread {
  id: string;
  title: string;
  messages: IForummessage[];
}
export interface ITimeRange {
  id?: number;
  start: string;
  end: string;
  statusId: number;
  specificDate?: Date | null;
}

export interface IAvailability {
  id?: number;
  companyId: number;
  dayId: number;
  startTime: string;
  endTime: string;
  isAvailable: boolean;
  statusId: number;
  specificDate?: string | null;
}

export interface ITreatmentPlan {
  appointmentsProgram: IAppointmentProgram;
  createUserName: string | null;
  user?: TUserAppointment;
  users?: TUserAppointment[];
  treatmentGroupName?: string | null;
  mediaName: string | null;
  genderName?: string | null;
  migzarName?: string | null;
  therapistUserName: string | null;
  therapistsGuid: string | null;
  period: string | null;
  sequenceCount: number;
}

export interface IAppointmentProgramErrorResponse {
  success: "false";
  error_code: string;
  message: string;
}

export interface IAppointmentProgram {
  id: number;
  companyId: number;
  companyServicesId?:number | null;
  name: string;
  genderId: number;
  migzarId: number;
  vetek: number;
  specializationsId: number;
  usersGuid: string;
  therapistsGuid?: string | null;
  roleId: number;
  countOfAppointments: number;
  appointmentsDurationsId: number;
  mediasId: number;
  appointmentsSequenceId: number;
  createDate: string;
  comments?: string;
  statusId: number;
  updateUsersGuid: string | null;
  therapistsId?: number | null;
  usersId?: number | null;
  treatmentGroupId?: number | null;
  appointmentsDurationsOpenMinutes?: number | null;
  appointmentsSequenceOpenCountInPeriod?: number | null;
  createUsersId: number;
  createUsersGuid?: string;
  updateTherapistsUsersId?: number | null;
  updateTherapistsDate?: Date | null;
  deleteType?: number | null;
  dateToDelete?: string | null;
  updateUsersId: string | number | null;
  updateDate: string | null;
  protocolId?: number | null;
  therapistsSpecializationsIds?: number[] | null;
  fundingSourcesId?: number | null;
  treatmentTypesId?: number | null;
  treatmentRoomId?: number | null;
  treatmentRoomName?: string | null;
  available?: boolean;
  users?: TUserAppointment[];
  isApproved?:boolean;
}

export type TAppointmentsProgramsTherapist = {
  therapistsId: number;
  therapistsGuid: string;
  fullName: string;
  freeWeek: number;
  optionPrograms: unknown | null;
};

export type IAppointmentsProgramsDataWithLabels = {
  [K in keyof IAppointmentsProgramsMetaData]: IAppointmentsProgramsMetaData[K] extends Array<
    infer U
  >
  ? Array<AddLabelAndValue<U>>
  : IAppointmentsProgramsMetaData[K];
};
export type TCompanyService = {
  Id: number;
  Name: string;
  StatusId: number;
}
export type TTreatmentRoom = {
  Id: number;
  Name: string; 
  Capacity: number;
  Location: string;
}

export interface IAppointmentsProgramsMetaData {
  Medias: TNamedItem[];
  Roles: TNamedItem[];
  Periods: IPeriod[];
  AppointmentsDurations: IAppointmentDuration[];
  AppointmentsSequence: IAppointmentSequence[];
  Genders: TNamedItem[];
  Migzars: TNamedItem[];
  AppointmentsProgramsStatus: TAppointmentsProgramsStatus[];
  TherapistsSpecializations: TNamedItem[];
  FundingSources: TNamedItem[];
  TreatmentTypes: TNamedItem[];
  CompanyServicesList: TCompanyService[];
  TreatmentRoomsList: TTreatmentRoom[];
}
export type TAppointmentsProgramsStatus = {
  Id: number;
  Desc: string;
};
export interface IPeriod {
  Id: number;
  Name: string;
  StatusId: number;
}

export interface IAppointmentSequence {
  Id: number;
  CompanyId: number;
  PeriodsId: number;
  CountInPeriod: number | null;
  IsOpen: boolean;
  StatusId: number;
}
export interface IAppointmentDuration {
  Id: number;
  CompanyId: number;
  Minutes: number | null;
  IsOpen: boolean;
  StatusId: number;
}
export type TActionReport = {
  duration: IOption | undefined;
  emd: IOption | undefined;
  reason: IOption[] | undefined;
  dsm: IOption[] | undefined;
  medicine: IOption[] | undefined;
  recommendations: IOption[] | undefined;
  rrm: IOption | undefined;
  treatmentWay: IOption | undefined;
};

export type TPrescriptionForm = {
  medicine: string | IOption;
  days: string;
  applicationOptions: string | IOption;
  dosage: string;
  dosageValue: string | IOption;
  numberTimesADay: string;
  instructions: string;
};
export type TLimits = {
  start: number;
  end: number;
};
export type TUserForm = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  birth: string;
  genderId: number;
  passport: string;
  [key: string]: any;
};

export type TChatNoteType = (typeof chatNoteTypes)[keyof typeof chatNoteTypes];

export interface IQuestionnaireData {
  id: number;
  desc: string;
  symbol: string;
  companyId: number;
  statusId: number;
  factorQuestionnaire: number;
  category: string;
  startQuestion: string;
}

export type TQuestionnaireButton = {
  buttonText: string;
  companyId: number;
  companyName: string | null;
  id: number;
  isUsers: boolean;
  questionnaireCompaniesTypeId: number;
  siteLink: string | null;
  statusId: number;
};

export type TBaseUser = {
  key: string;
  id: number;
  firstName: string;
  fullName: string;
  lastName: string | null;
  roleId: number;
  phone: string;
  email: string | null;
  birth: string | null;
  avatar: string | null;
  companyId: number;
  account: number | null;
  planId: number;
  fakeCompanyId: number | null;
  recommends?: null | string;
};

export type TServerUser = TBaseUser & {
  guid: string;
  account: string | null;
  password: string | null;
  passport: string | null;
  tempCode: string | null;
  address: string | null;
  planId: number;
  genderId: number | null;
  statusId: number;
  dateRegister: string | null;
  usersFlowId: string | null;
};

export type TGetUsersByTherapistIdResponse =
  | {
    TherapistUsers: TServerUser[]; // The first possible shape
  }
  | {
    success: string; // The second possible shape
    desc: string;
  };

export type TAddUserRequest = {
  id: number;
  guid: string;
  companyId: number;
  fakeCompanyId?: number | null;
  roleId: number;
  firstName: string;
  phone?: string;
  lastName?: string;
  email?: string;
  birth?: string;
  genderId: number;
  passport?: string;
  password?: string;
  statusId: number;
  roles?: { id: number };
  treatmentGroupId: number | null,
  cityId?: number | null;
  address?: string;

};

export interface IGetUserResponse {
  Account: null;
  Address: string;
  CityId: number | null;
  City: string | null;
  Birth: string; // ISO string, e.g., "1964-04-27T00:00:00"
  CompanyId: number;
  DateRegister: string; // ISO string, e.g., "2024-07-11T00:00:00"
  Email: string | null;
  FakeCompanyId: number | null;
  FirstName: string;
  GenderId: number | null;
  Id: number;
  Guid: string | null;
  LastName: string;
  Passport: string;
  Phone: string;
  PlanId: number;
  RoleId: number;
  StatusId: number;
}
export interface IUserReport {
  TotalReports: number;
  Recommends: string | null;
  RoleName: string | null;
  Users: IGetUserResponse;
}

export interface IGetUsersByCompanyIdWithRecommendsResponse {
  Users: IUserReport[];
}

export type TGetUsersRequest = {
  companyId: string | number;
  fakeCompanyId?: string | number;
  roleId?: string | number;
  recommendsId?: string | number;
  startDate?: string;
  endDate?: string;
};

export type TSetPasswordRequest = {
  userGuid: string;
  password: string;
  roleId: number;
};

export type TLabeledItem = {
  value: string;
  label: string;
};

export type TLabeledItemWithId = TLabeledItem & {
  id: number | null;
};

export type AddLabelAndValue<T> = T & {
  label: string | number;
  value: string | number;
};

export type TNamedItem = {
  Id: number;
  Name: string;
};

export type TCity = {
  id: number;
  name: string;
  nameEn?: string;
};

export type TLanguage = {
  id: number;
  name: string;
  enName: string;
  statusId: boolean;
  code: string;
  countryCode: string;
};

export interface Message {
  senderId: string;
  content: string;
  sentDate: string;
}

export interface MessageBlock {
  date: string;
  messages: Message[];
}

export type TLanguageCulture = {
  code: string;
  englishName: string;
  nativeName: string;
  countryCode: string;
};

export interface IUserAppTableRule {
  id: number;
  usersId: number | null;
  userName?: string;
  appTableId: number;
  tableName?: string;
  permissionId: number;
  permissionName?: string;
  scopeTypeId?: number;
  statusId: number;
  companyId?: number;
  granted?: boolean;
}

export type TClinicSummaryResponce = {
  clientReportsNum: number;
  therapistReportsNum: number;
  randomMeetingsNum: number;
  appointmentsProgramsMeetingsNum: number;
  activeAppointmentsProgramsNum: number;
  nonActiveAppointmentsProgramsNum: number;
};
export type TClinicSummary = TClinicSummaryResponce & {
  user: TTherapistUser;
};
export type TClinicalSummaryLatest = {
  id: number;
  version: number;
  updateReason: string;
  questionnaireId: number;
  summary: string;
  clinicalInsights: string | null;
  riskStatusPercent: number;
  createdAt: string;
  therapistResponse: string | null;
  updatedDate: string | null;
  updatedByUserName: string | null;
  previousSummaryId: number | null;
}
export type TClinicalSummaryHistoryItem = {
  id: number;
  version: number;
  updateReason: string;
  questionnaireId: number;
  summary: string;
  createdAt: string;
  therapistResponse: string | null;
  updatedDate: string | null;
  updatedByUserName: string | null;
  previousSummaryId: number | null;
}
export type TClinicalSummaryHistoryResponse = {
  success: boolean;
  userGuid: string;
  totalVersions: number;
  clinicalSummary: TClinicalSummaryLatest;
  summaries: TClinicalSummaryHistoryItem[];
}
export type TUpdateClinicalSummaryResponse = {
  success: boolean;
  summary: string;
  clinicalInsights?: string | null;
  riskStatusPercent?: number | null;
  updatedAt: string;
    therapistResponse: string;
}
export type TUpdateClinicalSummaryRequest = {
  userGuid: string;
  therapistResponse: string;
  language?: string;
}
export interface IUserComment {
  id: number;
  comment: string;
  createdOn: string;
  creatorId: number;
  creatorName: string;
}

export interface IPostUserCommentDto {
  usersGuid: string;
  comment: string;
}

export interface IPatchUserCommentDto {
  comment: string;
}

export type TIceServer = {
  urls: string | string[];
  username?: string;
  credential?: string;
};